import { Col, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { getFathers } from "data/apiConection.js/dataUsers";
import CardMeses from "./cards-pagos/CardMeses";

const Pagos = () => {
    const [father, setFather] = useState({});
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const f = await getFathers();
                setFather(f);
                console.log(father); // Log the data right after receiving it
                console.log(f);
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
        
        fetchData();
    }, []); // Empty dependency array means this runs once on mount

    return (
        <>
            <Row>
                  <Col>
                   {father && <CardMeses father = {father} />}
                </Col>
            </Row>
        </>
    );
}

export default Pagos;